export const order = {
  ALL: 'All',

  // Experience
  JOB: 'Jobs',

  // Publications
  COURSE: 'Courses',
  EXAM: 'Exams',
  DEGREE: 'Degrees',

  // Projects
  WEB: 'Websites',
  MOBILE: 'Mobile Apps',
  PERSONAL_PROJECTS: 'Personal Projects',

  // Certificates
  THESIS: 'Thesis',
  JOURNAL: 'Journal',
  CONFERENCE: 'Conference',

  // Skills
  CURRENT: 'Currently using',
  PAST_FREQUENTLY: 'I used in the past',
  PAST_OCCASIONALLY: 'I know a few things about',
};
